import React from 'react'
import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/deals/all', label: 'All Deals' },
  { path: '/deals/create', label: 'Create Deal' },
  { path: '/deals/quote-requested', label: 'Quote Requested' },
  { path: '/deals/quote-assessment', label: 'Quote Assessment' },
  { path: '/deals/collections', label: 'Collections' },
  { path: '/deals/warehousedropoff', label: 'Warehouse Drop-off' },
  { path: '/deals/payments', label: 'Payments' },
  { path: '/deals/store-credit', label: 'Store credit' },
  { path: '/deals/consignments', label: 'Consignments' },
  { path: '/deals/exceptions', label: 'Exceptions' },
  { path: '/deals/remainders', label: 'Remainders' },
  { path: '/deals/audio-raider', label: 'Audio Raider' }
]

function DealsPage() {
  // A Deals Reviewer is a normal Deals user in the nav and tabs. Only the Quote
  // Assessment PAGE changes for them (restricted actions + assigned-only scope),
  // not the menu (spec docs/archive/202609/specs_20260916_quote_review.md).
  return (
    <div className="page">
      <div className="pageHead">
        <h1>Deals</h1>
        <p>Manage quotes and deal workflows</p>
      </div>

      {/* "prefix", not "exact": /deals/part-ex/* must keep the Part Ex tab lit. */}
      <PageTabs tabs={tabs} match="prefix" />

      <Outlet />
    </div>
  )
}

export default DealsPage
